import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pyxis-app-forbidden',
  templateUrl: './app-forbidden.component.html',
  styleUrls: ['./app-forbidden.component.scss']
})
export class AppForbiddenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
